import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class PhoneVerificationRateLimitError extends CodedError {
  static get errorName() {
    return errorCodes.phoneVerificationRateLimitError.code;
  }

  constructor(
    message: string = errorCodes.phoneVerificationRateLimitError.message
  ) {
    super(message);
    this.code = errorCodes.phoneVerificationRateLimitError.code;
    this.status = errorCodes.phoneVerificationRateLimitError.status;
    this.message = `${message} ${errorCodes.phoneVerificationRateLimitError.code}`;
    this.name = errorCodes.phoneVerificationRateLimitError.name;
  }
}
